document.addEventListener("DOMContentLoaded", function () {
  const wishlistKey = "ma-meshop_wishlist";
  const addToWishlistBtns = document.querySelectorAll(".wishlist-btn");
  const popup = document.getElementById("wishlist-popup");
  const toggleBtn = document.getElementById("wishlist-toggle");
  const container = document.getElementById("wishlist-items");
  const countElem = document.getElementById("wishlist-count");
  const countElem2 = document.getElementById("card-wishlist-count");
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(wishlistKey)) || [];
    } catch {
      return [];
    }
  }
  renderWishlist();

  function updateCount() {
    const wishlist = getWishlist();
    if (countElem) countElem.textContent = wishlist.length;
    if (countElem2) countElem2.textContent = wishlist.length;
  }
  // ✅ Loop over all wishlist buttons and add "added" if handle exists in wishlist
  function updateWishlistButtons() {
    const wishlist = getWishlist();

    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
      const handle = btn.getAttribute("data-product-handle");

      // check if product handle is in wishlist array
      const exists = wishlist.some((item) => item.handle === handle);

      if (exists) {
        btn.classList.add("added");
      } else {
        btn.classList.remove("added");
      }
    });
  }
  function saveWishlist(items) {
    try {
      localStorage.setItem(wishlistKey, JSON.stringify(items));
    } catch { }
  }

  function renderWishlist() {
    const products = getWishlist();
    if (products.length === 0) {
      container.innerHTML = "<p>No products found in your wishlist.</p>";
      return;
    }
    //<svg xmlns="http://www.w3.org/2000/svg" class="icon-heart-s" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
    //  <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
    //    <path d="M 83.627 13.423 L 83.627 13.423 c -8.498 -8.498 -22.403 -8.498 -30.901 0 L 45 21.148 l -7.725 -7.725 c -8.498 -8.498 -22.403 -8.498 -30.901 0 s -8.498 22.403 0 30.901 l 13.247 13.247 c 0 0 0 0 0 0 L 45 82.951 l 25.379 -25.379 l 13.248 -13.248 C 92.124 35.826 92.124 21.921 83.627 13.423 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path>
    //  </g>
    //</svg>
    //<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-accordion icon-heart" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 5.24 8.515 3.773a4.433 4.433 0 0 0-6.21 0 4.293 4.293 0 0 0 0 6.128L10 17.495l7.695-7.593a4.293 4.293 0 0 0 0-6.128 4.433 4.433 0 0 0-6.21 0zm.765-2.177c2.113-2.084 5.538-2.084 7.65 0a5.29 5.29 0 0 1 0 7.55l-7.695 7.593a1.03 1.03 0 0 1-1.44 0l-7.696-7.594a5.29 5.29 0 0 1 0-7.549C3.697.98 7.122.98 9.234 3.063l.766.755z"></path></svg>

    container.innerHTML = products
      .map(
        (p) => `
        <div class="wishlist-item" style="margin-bottom:10px;">
          
          <div class="wishlist-item-wrapper">
            <div class="wishlist-item-img">

            <span class="wishlist-btn" 
              data-product-handle="${p.handle}"
              data-product-title="${p.title}" 
              data-product-image="${p.image}">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon-heart-s" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
                <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                  <path d="M 83.627 13.423 L 83.627 13.423 c -8.498 -8.498 -22.403 -8.498 -30.901 0 L 45 21.148 l -7.725 -7.725 c -8.498 -8.498 -22.403 -8.498 -30.901 0 s -8.498 22.403 0 30.901 l 13.247 13.247 c 0 0 0 0 0 0 L 45 82.951 l 25.379 -25.379 l 13.248 -13.248 C 92.124 35.826 92.124 21.921 83.627 13.423 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"></path>
                </g>
              </svg>
            </span>
              <a href="/products/${p.handle}">
                <img src="${p.image}"  />
              </a>
            </div>
            <div class="wishlist-item-content">
              <a href="/products/${p.handle}">
                <span>${p.title}</span>
              </a>
            </div>
          </div>
         
            
        </div>
      `
      )
      .join("");
  }

  toggleBtn.addEventListener("click", () => {
    renderWishlist();
    popup.style.display = "flex";
  });

  updateCount();
  updateWishlistButtons();




  const targetNode = document.getElementById("FacetFiltersPillsForm");

  if (targetNode) {
    const config = { childList: true, subtree: true, attributes: true };
    const callback = function () {
      updateWishlistButtons();
    };
    const obs = new MutationObserver(callback);
    obs.observe(targetNode, config);
  }


  // Function to attach an event to all elements matching a selector
  function attachEventToDynamicElements(selector, eventType, callback) {
    // Attach to existing elements
    document.querySelectorAll(selector).forEach((el) => {
      callback(el);
    });

    // Observe future added elements
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // only element nodes
            if (node.matches(selector)) {
              callback(node);
            }
            // Also check descendants of the added node
            node.querySelectorAll(selector).forEach((child) => {
              callback(child);
            });
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Usage
  attachEventToDynamicElements('.wishlist-btn', 'click', (el) => {
    el.addEventListener('click', () => {
      const productHandle = el.dataset.productHandle;
      const countElem = document.getElementById("wishlist-count");
      const countElem2 = document.getElementById("card-wishlist-count");

      let wishlist = JSON.parse(localStorage.getItem(wishlistKey) || "[]");

      // Check if product already in wishlist (by handle)
      const index = wishlist.findIndex((item) => item.handle === productHandle);

      if (index === -1) {
        // Not in wishlist, add it
        const product = {
          handle: productHandle,
          title: el.dataset.productTitle,
          image: el.dataset.productImage,
        };
        wishlist.push(product);
        el.classList.add("added");
        document.querySelector(".drawer").classList.add('active');
        document.querySelector(".drawer .card-wishlist").classList.add('active');
        document.querySelector(".drawer .wishlist-link").classList.add('active');

        document.querySelectorAll('.wishlist-btn').forEach((el) => {
          if (el.getAttribute("data-product-handle") == productHandle) {
            el.classList.add('added')
          }
        });
        // Update the count badge in header
        if (countElem) countElem.textContent = wishlist.length;
        if (countElem2) countElem2.textContent = wishlist.length;
      } else {
        // Already in wishlist, remove it
        wishlist.splice(index, 1);
        el.classList.remove("added");
        document.querySelectorAll('.wishlist-btn').forEach((el) => {
          if (el.getAttribute("data-product-handle") == productHandle) {
            el.classList.remove("added")
          }
        });
        // Update the count badge in header
        if (countElem) countElem.textContent = wishlist.length;
        if (countElem2) countElem2.textContent = wishlist.length;
      }

      localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
      renderWishlist();
    });
  });

});

